"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.content.placeholder': 'Inserisci contenuto della conoscenza',
};
